import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';

class PopoverController extends Controller {
  connect() {
    this.isOpen = this.popoverTarget.classList.contains('is-open');

    window.addEventListener('resize', PopoverController.closePopovers);
    window.addEventListener('scroll', PopoverController.closePopovers);
  }

  disconnect() {
    window.removeEventListener('resize', PopoverController.closePopovers);
    window.removeEventListener('scroll', PopoverController.closePopovers);
  }

  onTogglerClick() {
    PopoverController.closePopovers();

    this.isOpen = !this.isOpen;

    this.togglePopover();
  }

  onWindowClick({ target }) {
    const toggler = target.closest('[data-target*="popover.toggler"]');
    const popover = target.closest('[data-target*="popover.popover"]');

    if (!popover && !toggler) {
      this.isOpen = false;

      PopoverController.closePopovers();
    }
  }

  togglePopover() {
    this.togglerTarget.setAttribute('aria-expanded', this.isOpen);
    this.popoverTarget.classList.toggle('is-open', this.isOpen);
  }

  static closePopovers() {
    const popoverNodes = document.querySelectorAll('[data-target*="popover.popover"]');
    const popovers = toArray(popoverNodes);

    popovers.forEach((popover) => {
      popover.classList.remove('is-open');
    });
  }
}

PopoverController.targets = [
  'toggler',
  'popover',
];

export default PopoverController;
